import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminFooter from "./AdminFooter";
import AdminHeader from "./AdminHeader";
import CKEditor from "./MyEditor";
import {
  server_post_data,
  save_update_extra_add_on,
  get_extra_add_on,
} from "../../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  handleAphabetsChange,
  handleIaphabetnumberChange,
  handleURLChange,
  handleSuccess,
  handleError,
  handleSuccessSession,
  handleNumbersChange,
} from "../../CommonJquery/CommonJquery.js";
import { Link, useParams } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";
function PackageVenueAdd() {
  let sec_id = 0;
  let main_id = 0;
  const { id, eid } = useParams();
  if (eid) {
    sec_id = eid;
  }
  if (id) {
    main_id = id;
  }

  const [editorData, setEditorData] = useState("");
  const [error_show, seterror_show] = useState("");
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editBlogData, seteditBlogData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const retrievedAdminId = retrieveData("staff_id");

  useEffect(() => {
    const start_date = "";
    const end_date = "";
    const flag = "3";
    const call_id = sec_id;
    master_data_get(start_date, end_date, flag, call_id);
  }, []);

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("admin_id", retrievedAdminId);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_extra_add_on, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.length > 0) {
            seteditBlogData(Response.data.message[0]);
            setEditorData(Response.data.message[0].description);
            setSelectedValue(Response.data.message[0].fix_flexible);
            setEditorDatMainID(Response.data.message[0].primary_id);
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  const handleEditorChange = (event, editor) => {
    setEditorData(editor.getData());
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    seterror_show("");
    if (editorData.length > 0) {
      if (vaild_data) {
        setshowLoaderAdmin(true);
        let fd_from = combiled_form_data(form_data, null);
        fd_from.append("description_data", editorData);
        fd_from.append("admin_id", retrievedAdminId);
        fd_from.append("main_id", editorDataMainID);
        fd_from.append("venue_id_main", main_id);
        fd_from.append("fix_flexible", selectedValue);
        await server_post_data(url_for_save, fd_from)
          .then((Response) => {
            console.log(Response);
            setshowLoaderAdmin(false);
            if (Response.data.error) {
              handleError(Response.data.message);
            } else {
              handleSuccessSession(
                Response.data.message,
                `/VenueDeshboardEdit/${id}/ExtraAddonVenueView`
              );
            }
          })
          .catch((error) => {
            setshowLoaderAdmin(false);
          });
      }
    } else {
      seterror_show("Please Fill The Mandatory Information");
    }
  };

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
  };

  return (
    <div className="app-container app-theme-white body-tabs-shadow fixed-header">
      <div className={showLoaderAdmin ? "loading_website" : ""}></div>
      <AdminHeader />

      <div className="app-main">
        <AdminSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className="app-page-title">
              <div className="page-title-wrapper">
                <div className="page-title-heading">
                  <Link to="/admindashboard">
                    <div className="page-title-icon">
                      <i className="fa fa-home icon-gradient bg-mean-fruit"></i>
                    </div>
                  </Link>
                  <div>
                    ExtraAddOn Management
                    <div className="page-title-subheading">
                      Add and Edit ExtraAddOn
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-card mb-3 card">
              <div className="card-body">
                <h5 className="card-title">Add/Edit ExtraAddOn</h5>
                <form className="needs-validation" id="CarrerformData">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Title<span className="red_show">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control  trio_mandatory"
                        name="add_on_name"
                        id="add_on_name"
                        maxLength={100}
                        onInput={handleIaphabetnumberChange}
                        placeholder="Enter Title"
                        defaultValue={editBlogData.add_on_name || ""}
                      />
                      <span className="condition_error"></span>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Price<span className="red_show">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control  trio_mandatory"
                        name="add_on_price"
                        id="add_on_price"
                        placeholder="Enter price"
                        maxLength={100}
                        onInput={handleNumbersChange}
                        defaultValue={editBlogData.add_on_price || ""}
                      />
                      <span className="condition_error"></span>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Addon Type <span className="red_show">*</span>
                      </label>
                      <select
                        className="form-control trio_mandatory length_min"
                        name="gst_per"
                        id="gst_per"
                        value={selectedValue}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select Type</option>
                        <option value="0">Fixed</option>
                        <option value="1">Flexible</option>
                      </select>
                      <span className="condition_error"></span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label htmlFor="validationCustom01">
                        Description<span className="red_show">*</span>
                      </label>
                      <CKEditor
                        data_showe={editorData}
                        onChange={handleEditorChange}
                      />
                      <span className="condition_error">{error_show}</span>
                    </div>
                  </div>

                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() =>
                      handleSaveChangesdynamic(
                        "CarrerformData",
                        save_update_extra_add_on
                      )
                    }
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
}
export default PackageVenueAdd;
